import axios from "axios";
import { buildNextPath } from "./authRedirect";
import { shouldRedirectToHostLogin } from "./requestAuth";

let authRedirectInProgress = false;

function buildLoginRedirectUrl() {
  const next = buildNextPath({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
  });

  return next && next !== "/login"
    ? `/login?next=${encodeURIComponent(next)}`
    : "/login";
}

function clearHostAuthState() {
  localStorage.removeItem("hostInfo");
  localStorage.removeItem("token");
  localStorage.removeItem("memberInfo");
  delete request.defaults.headers.common.Authorization;
}

const request = axios.create({
  baseURL:
    process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "https://api.bellhopt.com/api/v1"
      : "https://api.bellhopt.com/api/v1",

  withCredentials: true,
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      const err = {
        error: "No response from the server, please try again later",
      };
      const data = { response: { data: err } };
      return Promise.reject(data);
    }
    // On auth expiry: clear host auth and redirect to login. Backend uses
    // 440 for expired sessions and 401 for missing/invalid auth.
    if (shouldRedirectToHostLogin({
      status: error.response?.status,
      url: error.config?.url ?? "",
    })) {
      clearHostAuthState();
      if (!authRedirectInProgress) {
        authRedirectInProgress = true;
        window.location.replace(buildLoginRedirectUrl());
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default request;
